export default __webpack_public_path__ + "static/media/2.ad58b7f8.jpg";